import CommonModal from "../Common/CommonModal";
import { Btn, H6, Image, LI, UL } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";
import { ToggleModalProp } from "../../../../Type/UiKits";
import { ToggleChildModal } from "./ToggleChildModal";
import { Cancel, ConnectNewAccount, ParentToggleTitle } from "../../../../Constant";

export const ToggleParentModal = ({ nestedModal, closeAll, toggle, toggleNested, toggleAll }: ToggleModalProp) => {
  return (
    <div className="modal-toggle-wrapper">
      <UL className="modal-img d-flex flex-row simple-list">
        <LI><Image src={dynamicImage("gif/whatapp.gif")} alt="whatsapp" /></LI>
        <LI><Image src={dynamicImage("gif/instagram.gif")} alt="instagram" /></LI>
        <LI><Image src={dynamicImage("gif/facebook.gif")} alt="facebook" /></LI>
      </UL>
      <H6>{ParentToggleTitle}</H6>
      <Btn color="dark" className="rounded-pill w-100 mt-4" onClick={toggleNested}>{ConnectNewAccount}</Btn>
      <CommonModal fade={true} centered isOpen={nestedModal} toggle={toggleNested} onClosed={closeAll ? toggle : undefined}>
        <ToggleChildModal toggleAll={toggleAll}/>
      </CommonModal>
      <Btn color="white" className="rounded-pill w-100 dark-toggle-btn" type="button" onClick={toggle}>{Cancel}</Btn>
    </div>
  );
};
